export default "__VITE_ASSET__DZZc5k6C__"